<template>
    <div class="skeleton"></div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'SkeletonLoading',
    });
</script>

<style lang="scss" scoped>
    .skeleton {
        display: flex;
        position: relative;
        border-radius: 0.25rem;
        overflow: hidden;
        background-color: #f2f2f2;

        &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(
                90deg,
                rgba(#d4d4d4, 0) 0,
                rgba(#d4d4d4, 0.2) 20%,
                rgba(#d4d4d4, 0.5) 60%,
                rgba(#d4d4d4, 0)
            );
            animation: shimmer 1.15s infinite;
            content: '';
        }

        @keyframes shimmer {
            100% {
                transform: translateX(100%);
            }
        }
    }
</style>
